import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  LOAD_WAY_BILL_BY_ID,
  LOAD_WAY_BILL,
} from './actions';

import {
  createLoadListReducerWithBegin,
  createLoadParameterReducer,
} from '../../utils/getCrudConfig';
import { WAY_BILL_MODULE } from '../../configs/moduleNames';

const initialState = {
  loadingWayBillList: false,
  loadingCurrentWayBill: false,
  currentWayBill: {},
  wayBillList: [],
  wayBillListMeta: {},
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(WAY_BILL_MODULE + LOAD_WAY_BILL, 'wayBillList', 'loadingWayBillList'),
  ...createLoadParameterReducer(WAY_BILL_MODULE + LOAD_WAY_BILL_BY_ID, 'currentWayBill', 'loadingCurrentWayBill'),
}, initialState);

export default reducer;

export const getWayBillData = createSelector(
  [state => state[WAY_BILL_MODULE]],
  state => {
    const {
      loadingWayBillList,
      loadingCurrentWayBill,
      currentWayBill,
      wayBillList,
      wayBillListMeta,
    } = state;
    return {
      loadingWayBillList,
      loadingCurrentWayBill,
      currentWayBill,
      wayBillList,
      wayBillListMeta,
    };
  },
);
